import React, { useState, useContext } from "react";

const UpdateMessageContext = React.createContext();

const useUpdateMessage = () => useContext(UpdateMessageContext);

const UpdateMessageProvider = ({ children }) => {
  const [updateMessage, setUpdateMessage] = useState(false);

  return (
    <UpdateMessageContext.Provider value={{ updateMessage, setUpdateMessage }}>
      {children}
    </UpdateMessageContext.Provider>
  );
};

export { useUpdateMessage, UpdateMessageProvider };
